import { Injectable } from '@angular/core';

import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

import { EnableClassTelemetry } from 'app/services/otel.service';

const IconDataBase = {
  avatars: {
    'ant-eater': 'assets/icons/avatars/ant-eater.svg',
    badger: 'assets/icons/avatars/badger.svg',
    bear: 'assets/icons/avatars/bear.svg',
    bull: 'assets/icons/avatars/bull.svg',
    camel: 'assets/icons/avatars/camel.svg',
    cat: 'assets/icons/avatars/cat.svg',
    chameleon: 'assets/icons/avatars/chameleon.svg',
    cow: 'assets/icons/avatars/cow.svg',
    // 'cow-1': 'assets/icons/avatars/cow-1.svg',
    crocodile: 'assets/icons/avatars/crocodile.svg',
    deer: 'assets/icons/avatars/deer.svg',
    dog: 'assets/icons/avatars/dog.svg',
    dolphin: 'assets/icons/avatars/dolphin.svg',
    donkey: 'assets/icons/avatars/donkey.svg',
    duck: 'assets/icons/avatars/duck.svg',
    elephant: 'assets/icons/avatars/elephant.svg',
    fish: 'assets/icons/avatars/fish.svg',
    fox: 'assets/icons/avatars/fox.svg',
    giraffe: 'assets/icons/avatars/giraffe.svg',
    goat: 'assets/icons/avatars/goat.svg',
    goose: 'assets/icons/avatars/goose.svg',
    hedgehog: 'assets/icons/avatars/hedgehog.svg',
    hippopotamus: 'assets/icons/avatars/hippopotamus.svg',
    horse: 'assets/icons/avatars/horse.svg',
    kangaroo: 'assets/icons/avatars/kangaroo.svg',
    koala: 'assets/icons/avatars/koala.svg',
    lion: 'assets/icons/avatars/lion.svg',
    monkey: 'assets/icons/avatars/monkey.svg',
    moose: 'assets/icons/avatars/moose.svg',
    mouse: 'assets/icons/avatars/mouse.svg',
    panda: 'assets/icons/avatars/panda.svg',
    panther: 'assets/icons/avatars/panther.svg',
    penguin: 'assets/icons/avatars/penguin.svg',
    pig: 'assets/icons/avatars/pig.svg',
    rabbit: 'assets/icons/avatars/rabbit.svg',
    racoon: 'assets/icons/avatars/racoon.svg',
    raven: 'assets/icons/avatars/raven.svg',
    rhinoceros: 'assets/icons/avatars/rhinoceros.svg',
    rooster: 'assets/icons/avatars/rooster.svg',
    seal: 'assets/icons/avatars/seal.svg',
    sheep: 'assets/icons/avatars/sheep.svg',
    snail: 'assets/icons/avatars/snail.svg',
    snake: 'assets/icons/avatars/snake.svg',
    squirrel: 'assets/icons/avatars/squirrel.svg',
    tiger: 'assets/icons/avatars/tiger.svg',
    turtle: 'assets/icons/avatars/turtle.svg',
    unicorn: 'assets/icons/avatars/unicorn.svg',
    vulture: 'assets/icons/avatars/vulture.svg',
    wolf: 'assets/icons/avatars/wolf.svg',
    zebra: 'assets/icons/avatars/zebra.svg',
  },
  'project-icons': {
    atm: 'assets/icons/project-icons/atm.svg',
    // 'atm-1': 'assets/icons/project-icons/atm-1.svg',
    // 'atm-2': 'assets/icons/project-icons/atm-2.svg',
    bag: 'assets/icons/project-icons/bag.svg',
    // 'bag-1': 'assets/icons/project-icons/bag-1.svg',
    // 'bag-2': 'assets/icons/project-icons/bag-2.svg',
    // 'bag-3': 'assets/icons/project-icons/bag-3.svg',
    // 'bag-4': 'assets/icons/project-icons/bag-4.svg',
    // 'bag-5': 'assets/icons/project-icons/bag-5.svg',
    // 'bag-6': 'assets/icons/project-icons/bag-6.svg',
    bank: 'assets/icons/project-icons/bank.svg',
    barbershop: 'assets/icons/project-icons/barbershop.svg',
    barcode: 'assets/icons/project-icons/barcode.svg',
    // 'barcode-1': 'assets/icons/project-icons/barcode-1.svg',
    basket: 'assets/icons/project-icons/basket.svg',
    // 'basket-1': 'assets/icons/project-icons/basket-1.svg',
    // 'basket-2': 'assets/icons/project-icons/basket-2.svg',
    box: 'assets/icons/project-icons/box.svg',
    // 'box-1': 'assets/icons/project-icons/box-1.svg',
    // 'box-2': 'assets/icons/project-icons/box-2.svg',
    // 'box-3': 'assets/icons/project-icons/box-3.svg',
    briefcase: 'assets/icons/project-icons/briefcase.svg',
    // 'briefcase-1': 'assets/icons/project-icons/briefcase-1.svg',
    calculator: 'assets/icons/project-icons/calculator.svg',
    cart: 'assets/icons/project-icons/cart.svg',
    // 'cart-1': 'assets/icons/project-icons/cart-1.svg',
    // 'cart-10': 'assets/icons/project-icons/cart-10.svg',
    // 'cart-11': 'assets/icons/project-icons/cart-11.svg',
    // 'cart-12': 'assets/icons/project-icons/cart-12.svg',
    // 'cart-13': 'assets/icons/project-icons/cart-13.svg',
    // 'cart-14': 'assets/icons/project-icons/cart-14.svg',
    // 'cart-15': 'assets/icons/project-icons/cart-15.svg',
    // 'cart-16': 'assets/icons/project-icons/cart-16.svg',
    // 'cart-17': 'assets/icons/project-icons/cart-17.svg',
    // 'cart-2': 'assets/icons/project-icons/cart-2.svg',
    // 'cart-3': 'assets/icons/project-icons/cart-3.svg',
    // 'cart-4': 'assets/icons/project-icons/cart-4.svg',
    // 'cart-5': 'assets/icons/project-icons/cart-5.svg',
    // 'cart-6': 'assets/icons/project-icons/cart-6.svg',
    // 'cart-7': 'assets/icons/project-icons/cart-7.svg',
    // 'cart-8': 'assets/icons/project-icons/cart-8.svg',
    // 'cart-9': 'assets/icons/project-icons/cart-9.svg',
    cashier: 'assets/icons/project-icons/cashier.svg',
    // 'cashier-1': 'assets/icons/project-icons/cashier-1.svg',
    change: 'assets/icons/project-icons/change.svg',
    check: 'assets/icons/project-icons/check.svg',
    coin: 'assets/icons/project-icons/coin.svg',
    // 'coin-1': 'assets/icons/project-icons/coin-1.svg',
    // 'coin-10': 'assets/icons/project-icons/coin-10.svg',
    // 'coin-2': 'assets/icons/project-icons/coin-2.svg',
    // 'coin-3': 'assets/icons/project-icons/coin-3.svg',
    // 'coin-4': 'assets/icons/project-icons/coin-4.svg',
    // 'coin-5': 'assets/icons/project-icons/coin-5.svg',
    // 'coin-6': 'assets/icons/project-icons/coin-6.svg',
    // 'coin-7': 'assets/icons/project-icons/coin-7.svg',
    // 'coin-8': 'assets/icons/project-icons/coin-8.svg',
    // 'coin-9': 'assets/icons/project-icons/coin-9.svg',
    coins: 'assets/icons/project-icons/coins.svg',
    // 'coins-1': 'assets/icons/project-icons/coins-1.svg',
    crate: 'assets/icons/project-icons/crate.svg',
    // 'crate-1': 'assets/icons/project-icons/crate-1.svg',
    // 'crate-2': 'assets/icons/project-icons/crate-2.svg',
    // 'crate-3': 'assets/icons/project-icons/crate-3.svg',
    // 'crate-4': 'assets/icons/project-icons/crate-4.svg',
    // 'crate-5': 'assets/icons/project-icons/crate-5.svg',
    'credit-card': 'assets/icons/project-icons/credit-card.svg',
    // 'credit-card-1': 'assets/icons/project-icons/credit-card-1.svg',
    // 'credit-card-2': 'assets/icons/project-icons/credit-card-2.svg',
    // 'credit-card-3': 'assets/icons/project-icons/credit-card-3.svg',
    // 'credit-card-4': 'assets/icons/project-icons/credit-card-4.svg',
    // 'credit-card-5': 'assets/icons/project-icons/credit-card-5.svg',
    // 'credit-card-6': 'assets/icons/project-icons/credit-card-6.svg',
    'delivery-cart': 'assets/icons/project-icons/delivery-cart.svg',
    // 'delivery-cart-1': 'assets/icons/project-icons/delivery-cart-1.svg',
    diagram: 'assets/icons/project-icons/diagram.svg',
    // 'diagram-1': 'assets/icons/project-icons/diagram-1.svg',
    // 'diagram-2': 'assets/icons/project-icons/diagram-2.svg',
    // 'diagram-3': 'assets/icons/project-icons/diagram-3.svg',
    folder: 'assets/icons/project-icons/folder.svg',
    // 'folder-1': 'assets/icons/project-icons/folder-1.svg',
    'get-money': 'assets/icons/project-icons/get-money.svg',
    graph: 'assets/icons/project-icons/graph.svg',
    // 'graph-1': 'assets/icons/project-icons/graph-1.svg',
    // 'graph-2': 'assets/icons/project-icons/graph-2.svg',
    // 'graph-3': 'assets/icons/project-icons/graph-3.svg',
    // 'graph-4': 'assets/icons/project-icons/graph-4.svg',
    // 'graph-5': 'assets/icons/project-icons/graph-5.svg',
    // 'graph-6': 'assets/icons/project-icons/graph-6.svg',
    // 'graph-7': 'assets/icons/project-icons/graph-7.svg',
    // 'graph-8': 'assets/icons/project-icons/graph-8.svg',
    grocery: 'assets/icons/project-icons/grocery.svg',
    // 'grocery-1': 'assets/icons/project-icons/grocery-1.svg',
    'insert-coin': 'assets/icons/project-icons/insert-coin.svg',
    investment: 'assets/icons/project-icons/investment.svg',
    justice: 'assets/icons/project-icons/justice.svg',
    'justice-scale': 'assets/icons/project-icons/justice-scale.svg',
    megaphone: 'assets/icons/project-icons/megaphone.svg',
    money: 'assets/icons/project-icons/money.svg',
    notes: 'assets/icons/project-icons/notes.svg',
    // 'notes-1': 'assets/icons/project-icons/notes-1.svg',
    // 'notes-2': 'assets/icons/project-icons/notes-2.svg',
    open: 'assets/icons/project-icons/open.svg',
    pack: 'assets/icons/project-icons/pack.svg',
    'pie-chart': 'assets/icons/project-icons/pie-chart.svg',
    // 'pie-chart-1': 'assets/icons/project-icons/pie-chart-1.svg',
    // 'pie-chart-2': 'assets/icons/project-icons/pie-chart-2.svg',
    // 'pie-chart-3': 'assets/icons/project-icons/pie-chart-3.svg',
    // 'pie-chart-4': 'assets/icons/project-icons/pie-chart-4.svg',
    // 'pie-chart-5': 'assets/icons/project-icons/pie-chart-5.svg',
    // 'pie-chart-6': 'assets/icons/project-icons/pie-chart-6.svg',
    'piggy-bank': 'assets/icons/project-icons/piggy-bank.svg',
    // 'piggy-bank-1': 'assets/icons/project-icons/piggy-bank-1.svg',
    'point-of-service': 'assets/icons/project-icons/point-of-service.svg',
    poor: 'assets/icons/project-icons/poor.svg',
    presentation: 'assets/icons/project-icons/presentation.svg',
    // 'presentation-1': 'assets/icons/project-icons/presentation-1.svg',
    // 'presentation-10': 'assets/icons/project-icons/presentation-10.svg',
    // 'presentation-11': 'assets/icons/project-icons/presentation-11.svg',
    // 'presentation-12': 'assets/icons/project-icons/presentation-12.svg',
    // 'presentation-13': 'assets/icons/project-icons/presentation-13.svg',
    // 'presentation-14': 'assets/icons/project-icons/presentation-14.svg',
    // 'presentation-15': 'assets/icons/project-icons/presentation-15.svg',
    // 'presentation-16': 'assets/icons/project-icons/presentation-16.svg',
    // 'presentation-17': 'assets/icons/project-icons/presentation-17.svg',
    // 'presentation-18': 'assets/icons/project-icons/presentation-18.svg',
    // 'presentation-19': 'assets/icons/project-icons/presentation-19.svg',
    // 'presentation-2': 'assets/icons/project-icons/presentation-2.svg',
    // 'presentation-3': 'assets/icons/project-icons/presentation-3.svg',
    // 'presentation-4': 'assets/icons/project-icons/presentation-4.svg',
    // 'presentation-5': 'assets/icons/project-icons/presentation-5.svg',
    // 'presentation-6': 'assets/icons/project-icons/presentation-6.svg',
    // 'presentation-7': 'assets/icons/project-icons/presentation-7.svg',
    // 'presentation-8': 'assets/icons/project-icons/presentation-8.svg',
    // 'presentation-9': 'assets/icons/project-icons/presentation-9.svg',
    'price-tag': 'assets/icons/project-icons/price-tag.svg',
    // 'price-tag-1': 'assets/icons/project-icons/price-tag-1.svg',
    // 'price-tag-2': 'assets/icons/project-icons/price-tag-2.svg',
    // 'price-tag-3': 'assets/icons/project-icons/price-tag-3.svg',
    // 'price-tag-4': 'assets/icons/project-icons/price-tag-4.svg',
    // 'price-tag-5': 'assets/icons/project-icons/price-tag-5.svg',
    // 'price-tag-6': 'assets/icons/project-icons/price-tag-6.svg',
    // 'price-tag-7': 'assets/icons/project-icons/price-tag-7.svg',
    // 'price-tag-8': 'assets/icons/project-icons/price-tag-8.svg',
    // 'price-tag-9': 'assets/icons/project-icons/price-tag-9.svg',
    receipt: 'assets/icons/project-icons/receipt.svg',
    record: 'assets/icons/project-icons/record.svg',
    'rewind-time': 'assets/icons/project-icons/rewind-time.svg',
    rich: 'assets/icons/project-icons/rich.svg',
    safebox: 'assets/icons/project-icons/safebox.svg',
    // 'safebox-1': 'assets/icons/project-icons/safebox-1.svg',
    // 'safebox-2': 'assets/icons/project-icons/safebox-2.svg',
    // 'safebox-3': 'assets/icons/project-icons/safebox-3.svg',
    // 'safebox-4': 'assets/icons/project-icons/safebox-4.svg',
    stamp: 'assets/icons/project-icons/stamp.svg',
    // 'stamp-1': 'assets/icons/project-icons/stamp-1.svg',
    stand: 'assets/icons/project-icons/stand.svg',
    store: 'assets/icons/project-icons/store.svg',
    // 'store-1': 'assets/icons/project-icons/store-1.svg',
    // 'store-2': 'assets/icons/project-icons/store-2.svg',
    // 'store-3': 'assets/icons/project-icons/store-3.svg',
    strongbox: 'assets/icons/project-icons/strongbox.svg',
    suitcase: 'assets/icons/project-icons/suitcase.svg',
    // 'suitcase-1': 'assets/icons/project-icons/suitcase-1.svg',
    // 'suitcase-2': 'assets/icons/project-icons/suitcase-2.svg',
    'time-is-money': 'assets/icons/project-icons/time-is-money.svg',
    'time-passing': 'assets/icons/project-icons/time-passing.svg',
    wallet: 'assets/icons/project-icons/wallet.svg',
    // 'wallet-1': 'assets/icons/project-icons/wallet-1.svg',
    // 'wallet-2': 'assets/icons/project-icons/wallet-2.svg',
    yen: 'assets/icons/project-icons/yen.svg',
  },
};

@EnableClassTelemetry()
@Injectable()
export class IconService {
  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {}

  public registerSvgIcons() {
    this.matIconRegistry.addSvgIcon(
      'dashboard',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/dashboard-blue.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'menu',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/menu-blue.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'search',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/search-blue.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'document',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/document-black.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'analysis',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/analysis-black.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'date',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/date-black.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'info',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/info-blue.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'question',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/question-black.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'upload',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/upload-gray.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'delete',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/delete-gray.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'arrow-right',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/right-gray.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'check',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/check-gray.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'account',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/account-gray.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'home',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/house-gray.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'clock',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/clock-gray.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'logout',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/logout-gray.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'folder-open',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/settings-blue-24-px.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'config-route',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/icon-12-px-route.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'check',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/check.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'downloading',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/downloading.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'horizontal_rule',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/horizontal_rule.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'xi_trash',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/xi-icons/trash.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'xi_add_circle',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/xi-icons/add_circle.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'xi_add_circle_filled',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/xi-icons/add_circle_filled.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'xi_cancel_circle',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/xi-icons/cancel_circle.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'xi_cancel_circle_filled',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/xi-icons/cancel_circle_filled.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'xi_cancel',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/xi-icons/cancel.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'xi_copy',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/xi-icons/copy.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'xi_download',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/xi-icons/download.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'xi_single_arrow_left',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/xi-icons/single_arrow_left.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'xi_single_arrow_right',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/xi-icons/single_arrow_right.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'xi_sort_order_desc',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/xi-icons/sort_order_desc.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'xi_exchange',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/xi-icons/exchange.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'xi_folder',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/xi-icons/folder.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'xi_chart',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/xi-icons/chart.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'xi_chart_1',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/xi-icons/chart_1.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'xi_collections',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/xi-icons/collections.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'xi_photo',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/xi-icons/photo.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'xi_play',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/xi-icons/play.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'xi_document_ext_csv',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/xi-icons/document_ext_csv.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'xi_document',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/xi-icons/document.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'xi_list_view',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/xi-icons/list_view.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'xi_view_table',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/xi-icons/view_table.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'xi_warning_filled',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/xi-icons/warning_filled.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'xi_refresh',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/xi-icons/refresh.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'xi_kabob',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/xi-icons/kabob.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'xi_reporting',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/xi-icons/reporting.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'xi_sentiment_positive',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/xi-icons/sentiment_positive.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'xi_visibility',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/xi-icons/visibility.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'xi_filter',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/xi-icons/filter.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'xi_settings',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/xi-icons/settings.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'xi_edit',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/xi-icons/edit.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'xi_search',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/xi-icons/search.svg')
    );
  }

  // TODO: for uploads a new method will be introduced that takes the project's source and if it is
  //       'custom' then it will search for it through wherever we store them.
  public listByType(type: string): string[] {
    return Object.keys(IconDataBase[type]);
  }

  public getByTypeAndId(type: string, id: string): string {
    if (type === 'project-icons' && id.endsWith('.svg')) {
      const parts = id.split('/');
      id = parts.slice(-1).pop().replace('.svg', '');
    }
    return IconDataBase[type][id];
  }

  public getProjectIcon(iconUrl: string): string {
    if (!iconUrl) {
      return null;
    }
    return this.getByTypeAndId('project-icons', iconUrl);
  }
}
